import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/app.config';

export const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div style={{ padding: '50px 0' }}>
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={
                    <Button type="primary" onClick={() => navigate(ROUTES.HOME)}>
                        Back Home
                    </Button>
                }
            />
        </div>
    );
};
